import type { SagaIterator } from 'redux-saga';
import { put, delay } from 'redux-saga/effects';
import { call as typedCall } from 'typed-redux-saga';
import { InvalidResponseCode, ResourceErrorInterface } from 'tg-resources';
import { apiFetch, apiPost } from './ApiSaga';
import api from '../Services/Api';
import type { ResetExpiredPassword, PasswordPolicy } from '../Redux/PasswordResetActions';
import {
  resetExpiredPasswordSuccess,
  resetExpiredPasswordFailed,
  receivePasswordPolicy,
  getPasswordPolicyFailed,
} from '../Redux/PasswordResetActions';
import { startLoading, finishLoading } from '../Redux/LoadingActions';
import { parseResponseTextError } from '../Utils/flattenError';

export function* getPasswordPolicySaga(): SagaIterator<void> {
  const { result, error } = yield* typedCall(apiFetch, api.txp.passwordPolicy, undefined, undefined);

  if (error) {
    yield put(getPasswordPolicyFailed());
  } else {
    const policy = result as PasswordPolicy;
    yield put(receivePasswordPolicy(policy));
  }
}

export function* resetExpiredPasswordSaga(action: ResetExpiredPassword): SagaIterator<void> {
  const { token, newPassword, confirmPassword } = action;

  yield delay(50);

  yield put(startLoading('resetExpiredPassword'));

  const { error } = yield* typedCall(apiPost, api.txp.resetExpiredPassword, undefined, {
    token,
    new_password: newPassword,
    confirm_password: confirmPassword,
  });

  if (error) {
    let errorMessage = 'Failed to reset password';
    let tokenExpired = false;

    if (error instanceof ResourceErrorInterface) {
      if (error instanceof InvalidResponseCode) {
        if (error.statusCode === 401) {
          tokenExpired = true;
          errorMessage = 'Password reset link has expired. Please request a new one.';
        } else {
          errorMessage = parseResponseTextError(error.responseText) || 'Failed to reset password';
        }
      } else if (error.isNetworkError) {
        errorMessage = 'Failed to reset password, are you online?';
      } else {
        errorMessage = 'Failed to reset password, try again later';
      }
    } else {
      errorMessage = 'Failed to reset password, try again later';
    }

    yield put(
      resetExpiredPasswordFailed({
        nonFieldError: errorMessage,
        tokenExpired,
      }),
    );
  } else {
    yield put(resetExpiredPasswordSuccess());
  }

  yield put(finishLoading('resetExpiredPassword'));
}
